/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createSeasonFromDiscriminatorValue, serializeSeason, serializeSeasonCreateRequest, serializeSeasonUpdateRequest, type ProblemDetails, type Season, type SeasonCreateRequest, type SeasonUpdateRequest } from '../models/index.js';
// @ts-ignore
import { GetForTourOperatorRequestBuilderRequestsMetadata, type GetForTourOperatorRequestBuilder } from './getForTourOperator/index.js';
// @ts-ignore
import { SeasonItemRequestBuilderNavigationMetadata, SeasonItemRequestBuilderRequestsMetadata, type SeasonItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Season
 */
export interface SeasonRequestBuilder extends BaseRequestBuilder<SeasonRequestBuilder> {
    /**
     * The GetForTourOperator property
     */
    get getForTourOperator(): GetForTourOperatorRequestBuilder;
    /**
     * Gets an item from the ApiSdk.Season.item collection
     * @param id Unique identifier of the item
     * @returns {SeasonItemRequestBuilder}
     */
     byId(id: number) : SeasonItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Season[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<SeasonRequestBuilderGetQueryParameters> | undefined) : Promise<Season[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Season>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: SeasonCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Season | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Season>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: SeasonUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Season | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SeasonRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SeasonCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: SeasonUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface SeasonRequestBuilderGetQueryParameters {
    isActive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const SeasonRequestBuilderUriTemplate = "{+baseurl}/Season";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SeasonRequestBuilderNavigationMetadata: Record<Exclude<keyof SeasonRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: SeasonItemRequestBuilderRequestsMetadata,
        navigationMetadata: SeasonItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    getForTourOperator: {
        requestsMetadata: GetForTourOperatorRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SeasonRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: "{+baseurl}/Season?isActive={isActive}",
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createSeasonFromDiscriminatorValue,
    },
    post: {
        uriTemplate: SeasonRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSeasonFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSeasonCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: SeasonRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSeasonFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSeasonUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
